import React, {useEffect, useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, TextField} from "@material-ui/core";
import PaymentMethod from '../../../entities/PaymentMethod';
import { AccountService, UpdatePaymentMethodRequest } from '../../../services/AccountService';
import { ServerResponse } from '../../../services/server/OldWebClient';

interface Props {
    paymentMethod?: PaymentMethod;
    openUpdateCardDialog: boolean;
    toggleUpdateCardDialog: () => void;
    updateCardInfo: (paymentMethod: PaymentMethod) => void;
    toggleShowErrorMessage: () => void;
    setErrorMessage: (message:string) => void;
}

export function UpdateCardDialog(props:Props) {
    const { paymentMethod, openUpdateCardDialog, toggleUpdateCardDialog, updateCardInfo, toggleShowErrorMessage, setErrorMessage} = props;

    const [disabled, setdisabled] = useState<boolean>(false);
    const [expirationYear, setExpirationYear] = useState<number>(0);
    const [expirationMonth, setExpirationMonth] = useState<number>(0);

    useEffect(() => {
        setExpirationYear(paymentMethod!.expirationYear);
        setExpirationMonth(paymentMethod!.expirationMonth);
    }, [paymentMethod])

    const onUpdatePayment = async () => {
        if (disabled || !paymentMethod) {
            return;
        }

        setdisabled(true)
        let request: UpdatePaymentMethodRequest = {
            paymentMethodId: paymentMethod.id,
            expirationMonth: expirationMonth,
            expirationYear: expirationYear
        };
        let paymentMethodResponse = await AccountService.updatePaymentMethod(request);
        if (ServerResponse.isSuccess(paymentMethodResponse)) {
            updateCardInfo(paymentMethodResponse.data);
        } else if(ServerResponse.isError(paymentMethodResponse)){
            setErrorMessage(paymentMethodResponse.message)
            toggleShowErrorMessage();
        }     

        setdisabled(false);
        toggleUpdateCardDialog();
    }


    return (
        <Dialog open={openUpdateCardDialog} onClose={() => toggleUpdateCardDialog} >
        <DialogTitle>Update your {paymentMethod!.cardBrand} card</DialogTitle>
        <DialogContent>
            <DialogContentText>Update the expiration date for your card ending with {paymentMethod!.lastFourOfCardNumber}.</DialogContentText>
            <br />
            <TextField
                label="Expiration Month"
                value={expirationMonth}
                type="number"
                inputProps={{
                    max: 12,
                    min: 1
                }}
                style={{ marginRight: 20, width: 125 }}
                onChange={e => {
                    let newExpirationMonth = parseInt(e.target.value, 10);
                    if (!isNaN(newExpirationMonth) && newExpirationMonth >= 1 && newExpirationMonth <= 12) {
                        setExpirationMonth(newExpirationMonth);
                    }
                }}
                disabled={disabled}
            />
            <TextField
                label="Expiration Year"
                value={expirationYear}
                type="number"
                inputProps={{
                    min: new Date().getFullYear()
                }}
                onChange={e => {
                    let newExpirationYear = parseInt(e.target.value, 10);
                    if (!isNaN(newExpirationYear)) {
                        setExpirationYear(newExpirationYear);
                    }
                }}
                disabled={disabled}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={toggleUpdateCardDialog} disabled={disabled} color="primary">
                Cancel
            </Button>
            <Button onClick={onUpdatePayment} disabled={disabled} color="primary">
                Submit
            </Button>
        </DialogActions>
    </Dialog>
    );
}